import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.print').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.printFlow, {
    url: '/flow',
    template: '<div>Loading</div>',
    controller: 'runnerPrintFlowController',
    controllerAs: '$ctrl'
  });
}
